<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Ordens de produção</h1>
            <p class="welcome-message">Gerencie as ordens de produção do estoque fabricado</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button type="button" mat-button (click)="imprimir()" [disabled]="_isLoading">
          <mat-icon class="material-symbols-outlined">print</mat-icon>
          <span>Imprimir</span>
        </button>

        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="acoesMenu">
          @if (selection.hasValue()) {
          <span>Ações ({{ selection.selected.length }})</span>
          } @else {
          <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #acoesMenu="matMenu">
          <button mat-menu-item (click)="imprimir()">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
            <span>Imprimir</span>
          </button>
          @if (podeLancarEstoque) {
          @if (selection.hasValue()) {
          <button mat-menu-item (click)="lancarEstoqueEmLote()">
            <mat-icon class="material-symbols-outlined">inventory</mat-icon>
            <span>Lançar estoque</span>
          </button>
          } @else {
          <button mat-menu-item disabled matTooltip="Selecione ao menos uma ordem de produção">
            <mat-icon class="material-symbols-outlined">inventory</mat-icon>
            <span>Lançar estoque</span>
          </button>
          }
          }
          @if (selection.hasValue()) {
          <button mat-menu-item (click)="imprimirEtiquetas()">
            <mat-icon class="material-symbols-outlined">label</mat-icon>
            <span>Imprimir etiqueta dos produtos</span>
          </button>
          } @else {
          <button mat-menu-item disabled matTooltip="Selecione ao menos uma ordem de produção">
            <mat-icon class="material-symbols-outlined">label</mat-icon>
            <span>Imprimir etiqueta dos produtos</span>
          </button>
          }
          @if (selection.hasValue() && podeAlterar) {
          <button mat-menu-item (click)="alterarTagsEmLote()">
            <mat-icon class="material-symbols-outlined">sell</mat-icon>
            <span>Alterar tags</span>
          </button>
          }
        </mat-menu>

        @if (podeInserir) {
        <button type="button" mat-flat-button class="btn-primary" (click)="novaOrdem()">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Incluir ordem de produção
        </button>
        }
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="pesquisa" placeholder="Número da OP, produto ou SKU" />
            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6 filter-container">
          <button mat-stroked-button type="button" class="btn-filter" [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosAvancados" [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu" (closed)="onFiltroMenuClosed()">
            <div class="filter-menu-content" [formGroup]="model">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros Avançados</h6>

                <div class="filter-menu__form">
                  <app-select-pesquisavel label="Status" [control]="$any(model.get('listIdStatus'))"
                    [idField]="'id'" [nameField]="'descricao'" [offlineList]="listaStatus" [multiple]="true"
                    [isOptional]="true" hint="Selecione o status">
                  </app-select-pesquisavel>

                  <app-select-pesquisavel label="Tags" [control]="$any(model.get('listIdTagProducao'))"
                    [idField]="'idTagProducao'" [nameField]="'descricao'" [offlineList]="listaTags" [multiple]="true"
                    [isOptional]="true" hint="Selecione tags" [corField]="'cor'">
                  </app-select-pesquisavel>
                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>
                  Aplicar
                </button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>

          <button mat-stroked-button type="button" class="btn-filter desktop-view" (click)="configurarColunas()">
            <mat-icon>view_column</mat-icon>
            Configurar Colunas
          </button>
        </div>
      </div>
    </form>

    @if (_dataSource.data.length > 0) {
    <div class="table-container desktop-view">
      <table mat-table [dataSource]="_dataSource">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="w-checkbox">
            <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let ordem" class="w-checkbox">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(ordem)"
              [checked]="selection.isSelected(ordem)"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="numero">
          <th mat-header-cell *matHeaderCellDef>Número</th>
          <td mat-cell *matCellDef="let ordem">
            <a class="numero-op link-numero-op" (click)="visualizar(ordem)">{{ ordem.numero }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="pedidos">
          <th mat-header-cell *matHeaderCellDef>Pedidos</th>
          <!-- Vínculo com pedido de venda não é escopo desta fase (seção 10 da US) -->
          <td mat-cell *matCellDef="let ordem" class="text-muted">--</td>
        </ng-container>

        <ng-container matColumnDef="dataInicio">
          <th mat-header-cell *matHeaderCellDef>Data início</th>
          <td mat-cell *matCellDef="let ordem">{{ ordem.dataInicio | date: 'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="dataPrevistaTermino">
          <th mat-header-cell *matHeaderCellDef>Data prevista de término</th>
          <td mat-cell *matCellDef="let ordem">
            {{ ordem.dataPrevistaTermino ? (ordem.dataPrevistaTermino | date: 'dd/MM/yyyy') : '--' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="produto">
          <th mat-header-cell *matHeaderCellDef>Código (SKU) - Descrição do produto</th>
          <td mat-cell *matCellDef="let ordem">
            <span class="produto-sku">{{ ordem.codigoSku }}</span>
            <span class="produto-nome">{{ ordem.nomeProduto }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="quantidade">
          <th mat-header-cell *matHeaderCellDef class="text-end">Quantidade</th>
          <td mat-cell *matCellDef="let ordem" class="text-end coluna-numerica">{{ ordem.quantidade }}</td>
        </ng-container>

        <ng-container matColumnDef="unidade">
          <th mat-header-cell *matHeaderCellDef>Un</th>
          <td mat-cell *matCellDef="let ordem" class="text-muted">{{ ordem.unidade }}</td>
        </ng-container>

        <ng-container matColumnDef="tags">
          <th mat-header-cell *matHeaderCellDef>Tags</th>
          <td mat-cell *matCellDef="let ordem">
            <div class="chips-tags">
              @for (tag of ordem.tags; track tag.idTagProducao) {
              <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="text-center">Status</th>
          <td mat-cell *matCellDef="let ordem" class="text-center celula-status">
            <span class="status-badge badge-dot" [ngClass]="classeBadgeStatus(ordem.idStatusOrdemProducao)">
              {{ nomeStatus(ordem) }}
            </span>
            @if (integracoes(ordem).length) {
            <span class="indicador-grid">
              @for (integracao of integracoes(ordem); track integracao.sigla) {
              <span class="indicador indicador-sm" [style.--indicador-cor]="integracao.cor" [matTooltip]="integracao.rotulo"
                [attr.aria-label]="integracao.rotulo">{{ integracao.sigla }}</span>
              }
            </span>
            }
            @if (ordem.idOrdemProducaoPai) {
            <span class="status-badge badge-azul chip-op-pai" matTooltip="Ordem gerada automaticamente">
              <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
              OP {{ ordem.numeroOrdemProducaoPai }}
            </span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="acoes">
          <th mat-header-cell *matHeaderCellDef class="text-center">Ações</th>
          <td mat-cell *matCellDef="let ordem" class="text-center">
            <button mat-icon-button class="btn-spinner" [class.btn-loading]="idOrdemProducaoEmAcao === ordem.idOrdemProducao"
              [matMenuTriggerFor]="linhaMenu" [disabled]="idOrdemProducaoEmAcao === ordem.idOrdemProducao"
              [attr.aria-label]="idOrdemProducaoEmAcao === ordem.idOrdemProducao ? 'Executando ação da ordem' : 'Ações'">
              <mat-icon>more_horiz</mat-icon>
              @if (idOrdemProducaoEmAcao === ordem.idOrdemProducao) { <mat-spinner diameter="20"></mat-spinner> }
            </button>
            <mat-menu #linhaMenu="matMenu">
              <button mat-menu-item (click)="visualizar(ordem)">
                <mat-icon class="material-symbols-outlined">visibility</mat-icon>
                <span>Visualizar</span>
              </button>
              <button mat-menu-item (click)="imprimir(ordem)">
                <mat-icon class="material-symbols-outlined">print</mat-icon>
                <span>Imprimir</span>
              </button>
              @if (podeAlterar) {
              <button mat-menu-item (click)="editar(ordem)" [disabled]="ordem.isEstoqueLancado"
                [matTooltip]="ordem.isEstoqueLancado ? 'Exclua o estoque para editar' : ''">
                <mat-icon class="material-symbols-outlined">edit</mat-icon>
                <span>Editar</span>
              </button>
              }
              @if (podeLancarEstoque && !ordem.isEstoqueLancado) {
              <button mat-menu-item (click)="lancarEstoque(ordem)">
                <mat-icon class="material-symbols-outlined">inventory</mat-icon>
                <span>Lançar estoque</span>
              </button>
              }
              @if (podeExcluirEstoque && ordem.isEstoqueLancado) {
              <button mat-menu-item (click)="excluirEstoque(ordem)">
                <mat-icon class="material-symbols-outlined">undo</mat-icon>
                <span>Excluir estoque</span>
              </button>
              }
              @if (podeInserir) {
              <button mat-menu-item (click)="gerarOrdensRelacionadas(ordem)">
                <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
                <span>Gerar ordens relacionadas</span>
              </button>
              }
              @if (podeExcluir) {
              <button mat-menu-item (click)="excluir(ordem)">
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                <span>Excluir</span>
              </button>
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div class="mobile-view">
      @for (ordem of _dataSource.data; track ordem.idOrdemProducao) {
      <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(ordem)">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(ordem)"
              [checked]="selection.isSelected(ordem)"></mat-checkbox>
            <a class="numero-op link-numero-op" (click)="visualizar(ordem)">OP {{ ordem.numero }}</a>
          </div>
          <div class="d-flex align-items-center gap-1">
            <span class="status-badge badge-dot" [ngClass]="classeBadgeStatus(ordem.idStatusOrdemProducao)">
              {{ nomeStatus(ordem) }}
            </span>
            @if (integracoes(ordem).length) {
            <span class="indicador-grid">
              @for (integracao of integracoes(ordem); track integracao.sigla) {
              <span class="indicador indicador-sm" [style.--indicador-cor]="integracao.cor" [matTooltip]="integracao.rotulo"
                [attr.aria-label]="integracao.rotulo">{{ integracao.sigla }}</span>
              }
            </span>
            }
            <button mat-icon-button class="btn-spinner" [class.btn-loading]="idOrdemProducaoEmAcao === ordem.idOrdemProducao"
              [matMenuTriggerFor]="linhaMenuMobile" [disabled]="idOrdemProducaoEmAcao === ordem.idOrdemProducao"
              (click)="$event.stopPropagation()"
              [attr.aria-label]="idOrdemProducaoEmAcao === ordem.idOrdemProducao ? 'Executando ação da ordem' : 'Ações'">
              <mat-icon>more_horiz</mat-icon>
              @if (idOrdemProducaoEmAcao === ordem.idOrdemProducao) { <mat-spinner diameter="20"></mat-spinner> }
            </button>
            <mat-menu #linhaMenuMobile="matMenu">
              <button mat-menu-item (click)="visualizar(ordem)">
                <mat-icon class="material-symbols-outlined">visibility</mat-icon>
                <span>Visualizar</span>
              </button>
              <button mat-menu-item (click)="imprimir(ordem)">
                <mat-icon class="material-symbols-outlined">print</mat-icon>
                <span>Imprimir</span>
              </button>
              @if (podeAlterar) {
              <button mat-menu-item (click)="editar(ordem)" [disabled]="ordem.isEstoqueLancado"
                [matTooltip]="ordem.isEstoqueLancado ? 'Exclua o estoque para editar' : ''">
                <mat-icon class="material-symbols-outlined">edit</mat-icon>
                <span>Editar</span>
              </button>
              }
              @if (podeLancarEstoque && !ordem.isEstoqueLancado) {
              <button mat-menu-item (click)="lancarEstoque(ordem)">
                <mat-icon class="material-symbols-outlined">inventory</mat-icon>
                <span>Lançar estoque</span>
              </button>
              }
              @if (podeExcluirEstoque && ordem.isEstoqueLancado) {
              <button mat-menu-item (click)="excluirEstoque(ordem)">
                <mat-icon class="material-symbols-outlined">undo</mat-icon>
                <span>Excluir estoque</span>
              </button>
              }
              @if (podeInserir) {
              <button mat-menu-item (click)="gerarOrdensRelacionadas(ordem)">
                <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
                <span>Gerar ordens relacionadas</span>
              </button>
              }
              @if (podeExcluir) {
              <button mat-menu-item (click)="excluir(ordem)">
                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                <span>Excluir</span>
              </button>
              }
            </mat-menu>
          </div>
        </div>
        <div class="card-body-mobile p-3">
          <div><strong>{{ ordem.codigoSku }}</strong> - {{ ordem.nomeProduto }}</div>
          <div class="text-muted">
            {{ ordem.quantidade }} {{ ordem.unidade }} · {{ ordem.dataInicio | date: 'dd/MM/yyyy' }}
          </div>
          @if (ordem.tags.length > 0) {
          <div class="chips-tags mt-2">
            @for (tag of ordem.tags; track tag.idTagProducao) {
            <app-ui-tag [text]="tag.descricao" [bgColor]="tag.cor"></app-ui-tag>
            }
          </div>
          }
        </div>
      </div>
      }
    </div>

    <div class="col-12 text-center">
      <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
        @if (_isLoading === true) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
        }
      </button>
    </div>
    } @else if (_isLoading === true) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (_carregou) {
    <app-empty-list [title]="'Nenhuma ordem encontrada'"
      [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
    }
  </div>
</div>